import React, { Component, Fragment } from "react";
import { TransactionsComponent } from "../../components/TransactionsComponent";
import { connect } from "react-redux";
import {
    getTransactions,
    getSuccessfulTransactions,
    getPendingTransactions,
} from "../../actions/transactions";

class Transaction extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.getTransactions();
        this.props.getSuccessfulTransactions();
        this.props.getPendingTransactions();
    }

    render(){
        return (
            <Fragment>
                <div className="container">
                    <div className="row m-0 p-0">
                        <div className="col-md-12 m-0 p-0">
                            <div className="dashboard-header-wrapper">
                                <h3 className="dashboard-header-text">Dashboard</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TransactionsComponent  transactions={this.props.transactions} title="All Transactions"  />
                        </div>
                        <div className="col-md-12">
                            <TransactionsComponent  transactions={this.props.successfulTransactions} title="Successful Transactions" />
                        </div>
                        <div className="col-md-12">
                            <TransactionsComponent transactions={this.props.pendingTransactions} title="Pending Transactions"  />
                        </div>
                    </div>

                </div>
            </Fragment>
        );
    }

}
const mapStateToProps = (state) => ({
    transactions: state.transactions.transactions,
    successfulTransactions: state.transactions.successfulTransactions,
    pendingTransactions: state.transactions.pendingTransactions
});
export default connect(mapStateToProps, { getTransactions, getSuccessfulTransactions, getPendingTransactions})(
    Transaction
);